export const fr = {
  ADD_COLOR_STRING_KEY: 'Ajouter une couleur',
  ADD_TEXT_KEY: 'Ajouter du texte',
  ADD_TO_ORDER_KEY: 'Ajouter à la commande',
  ADD_TO_CART: 'Ajouter au panier',
  ADD_TEMPLATE: 'Ajouter un modèle',
  ADJUST_SIZE_KEY: 'Ajuster la taille',
  ADJUST_TRANSPARENCY_KEY: 'Ajuster la transparence',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "En cliquant sur Terminé, vous acceptez les Conditions d'utilisation et la Déclaration de confidentialité HP.",
  ALIGN_BOTTOM_KEY: 'Aligner le bas',
  ALIGN_CENTER_KEY: 'aligner le centre',
  ALIGN_KEY: 'aligner',
  ALIGN_LEFT_KEY: 'début',
  ALIGN_MIDDLE_KEY: 'Align Middle',
  ALIGN_RIGHT_KEY: 'fin',
  ALIGN_TOP_KEY: 'Aligner en haut',
  ALL_TAB_TITLE_KEY: 'Tout',
  ALMOST_DONE_TITLE_KEY: "C'est presque terminé !",
  AND_KEY: 'et',
  APPLY_KEY: 'Appliquer',
  AREA_CODE: 'Indicatif régional',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Parcourez le contenu et sélectionnez les images pour votre création ou téléchargez les vôtres',
  BASIC_HELPER_INSTRUCTION2_KEY:
    "Affichez l'aperçu de votre création ou ajustez les détails",
  BASIC_HELPER_INSTRUCTION3_KEY:
    "Personnalisez la création et ajoutez d'autres éléments à votre projet",
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Une fois votre création prête, cliquez sur SUIVANT pour effectuer une dernière vérification et passer votre commande.',
  BACK_KEY: 'Retour',
  BACKGROUND_KEY: 'Arrière-plan',
  BACKGROUND_UPPER_CASE_KEY: 'ARRIÈRE-PLAN',
  BACKGROUND_CONTRAST_KEY: "Contraste de l'arrière-plan",
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Aucune inspiration trouvée dans cette catégorie',
  BRING_TO_FRONT_KEY: 'Mettre au premier plan',
  CANCEL_TEXT_KEY: ' Annuler ',
  CENTIMETERS_KEY: 'centimètres',
  CM_KEY: 'cm',
  CHANGE_YOUR_SETTINGS_KEY: 'Modifier les paramètres de votre projet',
  CHECKBOX_CONTENT1: 'Je souhaite recevoir la newsletter Pattern Design©',
  CHECKBOX_CONTENT2:
    "J'autorise HP à créer un compte dans les services de Pattern Design© en mon nom",
  CHOOSE_FROM_COMPUTER_KEY: "Choisir sur l'ordinateur",
  CHOOSE_RIP_OPTIONS:
    "Choisissez un des processeurs d'image tramée (RIP) de fournisseur tiers suivants",
  CHOOSE_FILE_KEY: 'Choisir un fichier',
  CITY: 'Ville',
  CLEAR_ALL_KEY: 'Tout effacer',
  CLEAR_COLOR_KEY: 'Effacer la couleur',
  CLOSE_WINDOW_KEY: 'Fermer la fenêtre',
  CLEAR_ALL_OBJECTS: 'Effacer tous les objets',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Cette opération supprimera tous les objets de votre arrière-plan.',
  CLEAR_DESIGN_KEY: 'Effacer la création',
  COLOR_KEY: 'Couleur',
  CONTINUE_KEY: 'Continuer...',
  COMPANY: 'Entreprise',
  CONGRATULATIONS_KEY: 'Félicitations !',
  CONFIRM_PASSWORD: 'Confirmez le mot de passe',
  CONFIRM_PATTERN_ACCOUNT_KEY:
    "Vous n'as pas encore de compte Pattern Design ?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Vous n'avez pas encore de compte Vecteezy?",
  COUNTRY: 'Pays',
  CREATE_ACCOUNT: 'Créer un compte',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Personnaliser',
  CUSTOM_PRICE_SIGN_IN_KEY:
    "Connectez-vous à l'étape suivante pour connaître votre prix personnalisé.",
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Créer',
  DESIGN_KEY: 'Création',
  DELETE_KEY: 'Supprimer',
  DOCUMENT_COLORS: 'Couleurs du document',
  DONE: 'Terminé !',
  DONE_KEY: 'Terminé',
  DONT_SHOW_ALERT_KEY: 'Ne plus afficher',
  DOWNLOAD_COLUMN_HEADER_KEY: 'Télécharger',
  DOWNLOAD_APP_TITLE_KEY: "Vous pouvez télécharger l'application ici :",
  DOWNLOAD_LINK_KEY: 'Téléchargez gratuitement HP Click ici',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Télécharger HP SmartStream',
  DOWNLOAD_INSTR_KEY:
    "Assurez-vous d'avoir installé HP Click avant de continuer",
  DOWNLOAD_SMARTSTREAM_KEY: 'Télécharger HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importation Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    "La taille de l'image doit être inférieure à 1 Go. Les formats PDF, PNG, JPG, SVG et TIFF sont acceptés.",
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Recherche Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Images Dreamstime',
  DUPLICATE_KEY: 'Dupliquer',
  EACH_ITEM_PRICE_KEY:
    "Votre création comprend du contenu émanant de l'un de nos fournisseurs de contenus Premium. Le prix unitaire de chaque élément est récapitulé ci-dessous.",
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Éditer la conception',
  EDIT_LOWERCASE_KEY: 'modifier',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    "Désolé, une erreur s'est produite. Réessayez plus tard.",
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    "Désolé, une erreur s'est produite lors de l'ouverture du fichier PDF téléchargé.",
  EMAIL_KEY: 'E-mail',
  EMAIL_ADDRESS_KEY: 'Adresse e-mail :',
  EMAIL_CHECKBOX_MESSAGE:
    "Je sais que cette personne comprend qu'elle recevra des e-mails envoyés par HP en mon nom ou par ce fournisseur de service.",
  EXTRA_INFO_KEY: 'Informations supplémentaires',
  EMAIL_NOTIFICATION:
    'Vous allez recevoir un e-mail très bientôt. Accordez-nous 15 minutes pour le traitement.',
  EMAIL_DIALOG_MESSAGE:
    "Entrez l'adresse e-mail de la personne avec laquelle vous souhaitez partager votre création.",
  ENTER_KEY: 'Accéder',
  EXISTING_FOLDER_KEY: 'Dossier existant',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Assurez-vous que tous les éléments sélectionnés sont corrects avant de procéder au paiement',
  FINAL_CHECK_TITLE_KEY: 'Vérification finale',
  FINISH_KEY: 'Finalisation',
  FINISH_LATER_KEY: 'Terminer plus tard',
  FIRSTNAME: 'Prénom',
  FISCAL_NUM: 'Numéro fiscal',
  FLIP_KEY: 'Retourner',
  FOR_KEY: 'pour',
  FORGOT_PASSWORD_KEY: 'Mot de passe oublié ?',
  FOTOLIA_KEYWORDS_KEY: 'Mots clés :',
  FOLDER_NAME: 'Nom du dossier',
  FOLDER_NAME_KEY: 'Nom du dossier :',
  FOLDER_ALREADY_EXIST_KEY: 'Ce nom de dossier existe déjà',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    'Vous venez de terminer la création de votre affiche gratuite',
  FREE_VECTOR_GRAPHICS_KEY: 'graphiques vectoriels gratuits',
  GETTY_IMAGE_SEARCH_TITLE: 'Recherche Getty Image',
  GOT_IT_MESSAGE_KEY: "OK, j'ai compris",
  GROUP_ALL_KEY: 'Tout regrouper',
  GROUP_SCALE: 'Échelle du groupe',
  GIFT_WRAPS_KEY: 'Emballages cadeaux',
  GIVE_PROJECT_NAME_KEY: 'Donnez un nom à votre projet',
  HEIGHT_KEY: 'Hauteur',
  TOUR_DESCRIPTION_TEXT:
    "Laissez-nous vous guider dans le processus de création. N'oubliez pas que vous pouvez rouvrir la présentation à tout moment en cliquant sur le bouton Aide.",
  HELP_KEY: 'Aide',
  HELPER_TITLE_KEY_1:
    'Créez des modèles d’affiche à partir d’une page vierge ou de millions d’images et de texte. Téléchargez votre propre contenu depuis des lecteurs locaux, Dropbox ou des médias sociaux',
  HELPER_TITLE_KEY_3:
    'Visualisez tous vos travaux de conception au même endroit',
  HELPER_TITLE_KEY_4:
    'Cliquez sur Suivant pour prévisualiser et terminer votre conception finale',
  HERE_KEY: 'ici',
  HELP_IMPROVE_KEY:
    "Améliorez votre productivité et l'efficacité de l'opérateur tout en ayant la possibilité de produire des couleurs.",
  HIGH_QUALITY_KEY: 'Des motifs',
  IMAGES_TITLE_KEY: 'Images',
  IMPERIAL_KEY: 'Impérial',
  IMPORTING_KEY: 'Importation',
  INCHES_COLUMN_HEADER_KEY: 'Pouces',
  INCHES_KEY: ' pouces',
  INCHES_UNIT_STRING_KEY: 'po',
  INVALID_EMAIL_ADDRESS_KEY: 'Adresse e-mail incorrecte',
  INVALID_INFO_KEY: 'Entrez des informations détaillées.',
  INVALID_NAME_KEY: 'Nom incorrect',
  INVALID_PRINTER_MODEL_KEY: "Modèle d'imprimante non valide",
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: "Type d'utilisateur non valide",
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Désolé, mais le fichier que vous avez sélectionné est trop volumineux. La taille maximum des fichiers est de 500 Mo.',
  INSUFFICIENT_CREDITS_KEY: 'Crédits insuffisants',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'Recherche iStock',
  INVALID_FILETYPE_ERROR_TEXT:
    "Désolé, ce format de fichier n'est pas valide. Seuls les formats PDF, JPG, PNG, SVG et TIFF sont pris en charge.",
  LANDSCAPE_KEY: 'Paysage',
  LANGUAGE_LABLE_KEY: 'Langue',
  LASTNAME: 'Nom de famille',
  LEARN_MORE: 'En savoir plus',
  LEARN_THE_BASICS_KEY: 'Apprendre les principes de base',
  LEGAL_FOOTER_MESSAGE1_KEY:
    "En utilisant ce site, vous acceptez d'être lié(e) par ces",
  LEGAL_FOOTER_MESSAGE2_KEY: 'Ce site Web respecte la/les',
  LEGAL_FOOTER_MESSAGE3_KEY: 'et la/les',
  LENGTH_STRING_IN_INCHES_KEY: 'po',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'changer',
  LINK_READER_APP_KEY: 'Application LinkReader',
  LINK_READER_APP_DESCRIPTION_KEY:
    "Pour visualiser le contenu que vous ajoutez, veuillez télécharger l'application LinkReader.",
  LOADING_KEY: 'Chargement...',
  LOADING_TEMPLATE_KEY: 'Chargement du gabarit',
  LOGIN_NOW: 'Connecte-toi maintenant',
  LOCK_KEY: 'Verrouiller',
  LOGIN_KEY: 'Se connecter',
  LOGIN_PATTERN_DESIGN_KEY: 'Se connecter à Pattern Design',
  LOGIN_SUBTITLE_KEY:
    'Connectez-vous pour connaître le prix personnalisé et les détails concernant le paiement',
  LOGIN_VECTEEZY_KEY: 'Se connecter à Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Connectez-vous à Dreamstime ',
  LOGOUT_KEY: 'Déconnexion',
  MATERIAL_TITLE_KEY: 'MATÉRIEL',
  MATERIAL_STRING_KEY: 'Matériau',
  MEASUREMENT_KEY: 'Mesure',
  METRIC_KEY: 'Métrique',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Modèle',
  MORE_INFO_TEXT_KEY: "Plus d'informations",
  MY_GIFTWRAPS_KEY: 'Mes cadeaux',
  MY_WORK_KEY: 'Mes travaux',
  MY_WORK_SAVE_KEY:
    'Votre conception a été enregistrée dans votre espace Mon travail',
  NAME_KEY: 'Nom :',
  NEXT_BUTTON_TITLE_KEY: 'Suivant',
  NEW_FOLDER_KEY: 'Nouveau dossier',
  NO_SHADOW_KEY: 'Sans ombre',
  OBJECT_QUANTITY_KEY: 'Quantité',
  OBJECTS_UPPER_CASE_KEY: 'OBJETS',
  OK_KEY: "D'accord",
  ORDER_SAMPLE_KEY: 'Commander un échantillon',
  ORDER_SAMPLE: 'Commander un échantillon',
  ORDER_SAMPLE_INFOLABEL_1:
    "Sélectionnez la partie de l'image à commander comme échantillon",
  ORDER_SAMPLE_INFOLABEL_2:
    'Vous allez recevoir un e-mail contenant une vue « en gros plan » de votre projet à sa taille réelle',
  ORDER_SAMPLE_INFOLABEL_3:
    'Cela vous aidera à évaluer sa qualité et sa résolution',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Commander un échantillon maintenant',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    "Recevez un e-mail contenant une vue en gros plan de votre projet à sa taille actuelle afin d'évaluer sa qualité/résolution.",
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: "Autres options d'impression",
  PASSWORD_KEY: 'Mot de passe',
  PATTERN_COLOR_KEY: 'Couleur du motif',
  PATTERN_DESIGN_TITLE_KEY: 'Création du motif',
  PATTERNS_FOR_KEY: 'de haute qualité',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'Échec de génération du fichier PDF. Réessayez.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Téléphone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    "Je confirme que je détiens les droits d’auteur sur cette image et j'accepte les",
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    "La taille de l'image doit être inférieure à 500 Mo. Les formats PNG, JPG, TIFF, SVG et PDF sont acceptés.",
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Entrez le texte ici...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    "Par ex., éléments importants que vous souhaitez communiquer au magasin d'impression.",
  PLACEHOLDER_INCHES_STRING_KEY: 'po',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'Mon affiche',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Position',
  PREMIUM_IMAGES_TITLE_KEY: 'Images Premium :',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Enregistrez votre projet',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Des modifications apportées à votre projet doivent être enregistrées avant de poursuivre.',
  PRICE_COLUMN_HEADER_KEY: 'Prix',
  PRINTER_SERIAL_NUMBER_KEY: "Numéro de série de l'imprimante*",
  PRINTING_ENABLE_DETAILS_KEY:
    "Pour activer l'impression, il ne nous manque plus que quelques détails supplémentaires",
  PRINTER_MODELS_KEY: "Modèles d'imprimante*",
  PROCESSING_KEY: 'Traitement...',
  PROCESSING_ALERT_TXT:
    'Ne fermez pas cette fenêtre pendant le traitement de votre création',
  PROCESSING_ALERT_TXT2:
    'Une fois le traitement terminé, HP Click démarrera automatiquement et commencera à télécharger votre fichier',
  PROCESSING_DONE: 'Vous avez presque terminé !',
  PROCESSING_FILE_TXT: 'Votre fichier est en cours de traitement.',
  PROCESSING_TIME_TXT:
    "Cette opération peut prend du temps car nous réalisons votre création pour vous garantir la meilleure qualité d'image possible",
  PROCESSING_ALERT_TXT3:
    'Votre fichier PDF sera automatiquement téléchargé sur votre ordinateur',
  PROCESSING_ALERT_TXT4:
    "N'oubliez pas que vous pouvez configurer votre connexion JDF en vue d'une automatisation dans les paramètres",
  PREMIUM_CONTENT_KEY: 'Contenu Premium',
  PREVIEW_KEY: 'Aperçu',
  PROFESSIONAL_USE_TITLE_KEY: 'conçus pour une utilisation professionnelle.',
  PROJECT_NAME_KEY: 'Nom du projet',
  PROJECT_NAME: 'Nom du projet :',
  PROJECT_ALREADY_EXIST_KEY: 'Ce nom de projet existe déjà',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Ce nom de projet existe déjà',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Ce nom de dossier existe déjà',
  PIXELATION_WARNING_KEY: 'Avertissement concernant la pixelisation',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    "En raison de la résolution de votre photo téléchargée, votre peau peut être déformée ou déformée. Pour vous assurer qu'il n'y a pas de flou, veuillez télécharger une image de bonne qualité et éviter l'étirement de l'image. Si vous êtes satisfait de l'aperçu et que vous souhaitez continuer, veuillez continuer à soumettre.",
  REGISTER_CONTACTINFO: 'Informations de contact',
  REGISTER_INFO: 'Enregistrer des informations',
  REGISTER_PATTERNSUB1: 'En tant que client valeur HP,',
  REQUIRED_FIELDS_KEY: 'Champs obligatoires',
  REQUIRED_FIELDS_TEXT_KEY: 'Champs obligatoires',
  REQUIRED_STRING_KEY: 'REQUIS',
  RECOLOR_KEY: 'Recolorer',
  RADICALLY_SIMPLE_KEY: "Logiciel d'impression d'une simplicité absolue",
  RIPSELECTION_HEAD:
    "Comme il s'agit de votre première utilisation, sélectionnez votre logiciel d'impression compatible préféré",
  RIPSELECTION_DESC:
    "Votre sélection sera utilisée comme votre chemin d'impression par défaut pour vos impressions futures. Vous pourrez modifier les paramètres par la suite",
  REGISTER_COMPANYINFO: 'Informations sur la société',
  REGISTER_KEY: "S'inscrire",
  REGISTER_NOW: "S'inscrire maintenant",
  REOLOR_KEY: 'Recolorer',
  REQUEST_SAMPLE_KEY: 'Demander un échantillon',
  RESIZE_KEY: 'Redimensionner',
  RESIZE_ARBITRARILY_KEY: 'Redimensionner arbitrairement',
  RESIZE_PROPORTIONALLY_KEY: 'Redimensionner proportionnellement',
  REVIEW_AND_SUBMIT_KEY: 'Examiner et soumettre',
  REQUEST_FOR_QUOTATION: 'Demander un devis',
  RIGHT_LOGO_TEXT_KEY: 'par',
  ROTATE_KEY: 'Pivoter',
  ROTATE_LEFT_KEY: 'Pivoter 90° à gauche',
  ROTATE_RIGHT_KEY: 'Pivoter 90° à droite',
  ROTATION_KEY: 'Rotation',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Lignes et colonnes',
  ROYALTY_FREE_KEY: 'vectoriels',
  ROYALTY_KEY: 'redevances',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Enregistrer',
  SAVING_KEY: 'Enregistrement...',
  SAVE_INSPIRATION: "Enregistrer l'inspiration",
  SAVE_TEMPLATE: 'Enregistrer le modèle',
  SAVE_DIALOG_TITLE: 'Enregistrez votre projet',
  SAVE_PROJECT_NAME_KEY: "Enregistrez d'abord votre projet",
  SAVEDIALOG_MESSAGE:
    'Connectez-vous pour enregistrer votre projet.Si vous ne possédez pas de compte, nous vous aiderons à en créer un. Votre travail ne sera pas perdu.',
  SEAMLESS_KEY: 'simples',
  SCALE_INFO_STRING_KEY:
    "Mettez l'image à l'échelle pour l'adapter à votre création",
  SCALE_KEY: "Mettre à l'échelle",
  SCALE_ALL_KEY: "Tout mettre à l'échelle",
  SCALE_TO_FILL_KEY: "Adapter l'échelle",
  SEARCH_BUTTON_TITLE_KEY: 'Rechercher',
  SELECT_CUSTOM_SIZE_KEY: 'Sélectionner une taille personnalisée',
  SELECT_CUSTOM_KEY: 'Personnaliser',
  SEARCH_TITLE: 'Rechercher',
  SELECTED_IMAGE_KEY: 'Image sélectionnée :',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Sélectionnez la taille des emballages cadeaux',
  SELECT_COUNTRY: 'Choisissez le pays',
  SELECT_SALUTATION: '---Sélectionner---',
  SELECT_POSTER_SIZE_KEY: "Sélectionnez la taille de l'affiche",
  SELECT_PRINTING_OPTION_KEY: "Sélectionnez votre option d'impression préférée",
  SEND_INSTALLATION_INSTRUCTION_KEY:
    "Envoyez-moi les instructions d'installation",
  SEND_TO_BACK_KEY: 'Placer derrière',
  SEND_KEY: 'Envoyer',
  SEND_TO_PRINT_TITLE_KEY: "Envoyer à l'impression",
  SET_SIZE_KEY: 'Définir la taille',
  SETTINGS_KEY: 'Paramètres',
  SETTINGS_UPPERCASE_KEY: 'PARAMÈTRES',
  SHARE_KEY: 'Partager',
  SIGNED_IN_AS_KEY: 'Connecté en tant que',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Connectez-vous ou inscrivez-vous pour connaître le prix personnalisé et les détails concernant le paiement',
  SIGN_UP_NOW_KEY: "S'inscrire maintenant",
  SKIP_KEY: 'Ignorer',
  SOLID_COLORS_KEY: 'Couleurs unies',
  SQFT_UNIT_STRING_KEY: 'pieds carrés',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Démarrer la présentation',
  STATUS_MSG: "Votre fichier a été envoyé à l'impression !",
  SUBMIT_BUTTON_KEY: 'Envoyer',
  SHARE_LINK_LABEL: 'Sélectionnez le type de lien à partager',
  SHARE_EDIT_LINK: 'Lien de modification',
  SHARE_VIEW_LINK: 'Lien de visualisation',
  SHARE_YOUR_CREATION: 'Partagez votre création !',
  STREET_ADD: 'adresse de rue',
  TARGET_VIEWING_HINT:
    '* La distance de visibilité ciblée peut être modifiée à partir des paramètres.',
  TERMS1_KEY: 'conditions',
  TERMS2_KEY: 'Déclaration de confidentialité HP',
  TERMS3_KEY: 'Avis concernant les droits sur les données personnelles HP',
  TERMS_OF_USE_KEY: "Conditions d'utilisation",
  TERMS_OF_USE: "Conditions d'utilisation.",
  TEXT_SHADOW_COLOR_KEY: "Couleur d'ombrage du texte",
  TEXT_ANCHOR_MIDDLE: 'milieu',
  TEXT_UPPERCASE_KEY: 'TEXTE',
  TILE_KEY: 'Mosaïque',
  TOTAL_KEY: 'TOTAL',
  TOTAL_PRICE_KEY: 'Total :',
  TRANSPARENCY_KEY: 'Transparence',
  TEMPLATES_KEY: 'des modèles',
  TEMPLATES_UPPER_CASE_KEY: 'MODÈLES',
  THANK_YOU_KEY: 'Merci',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Déverrouiller',
  UNGROUP_KEY: 'Dégrouper',
  UPDATE_TEXT_KEY: 'Mettre à jour',
  UPLOAD_KEY: 'Télécharger',
  UPLOAD_LOGO_KEY: 'Télécharger le logo',
  UPLOAD_IMAGE_KEY: 'Télécharger votre image vers le serveur',
  UPLOAD_UPPERCASE_KEY: 'TÉLÉCHARGER',
  USER_NAME: "Nom d'utilisateur",
  USER_TYPE_TITLE_KEY: "Quel type d'utilisateur êtes-vous*",
  UNTILE_KEY: 'Annuler mosaïque',
  UNSPLASH_SEARCH_TITLE: 'Recherche Unsplash',
  VALIDITY_KEY: 'Validité',
  VANILLA_LOGIN_DIALOG_KEY:
    'Inscrivez-vous gratuitement pour enregistrer et imprimer votre création et visualiser les travaux que vous avez enregistrés',
  VANILLA_PREVIEW_MESSAGE_KEY:
    "Ceci est l'aperçu de votre création, confirmez que votre création est finalisée ou sélectionnez Modifier pour apporter des modifications",
  VAT_KEY: 'TVA',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'libre de droits',
  VIEW_FOTOLIA_KEY: 'Afficher dans Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'Voir dans Getty Image©',
  VIEW_I_STOCK_KEY: 'Voir dans iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Afficher les détails de la création',
  VIEW_DESIGNER_PROFILE_KEY: 'Afficher le profil du créateur',
  VIEW_PRICE_KEY: 'Afficher le prix',
  VECTEEZY_SEARCH_TITLE: 'Recherche Vecteezy',
  WALL_POSTER_KEY: 'Affiches',
  WALL_SIZE_TEXT_KEY: 'Taille du mur',
  WARNING_KEY: 'Avertissement',
  WEBSITE: 'Site Internet',
  WIDTH_KEY: 'Largeur',
  YOU_CAN_ALWAYS_ACCESS: 'Vous pouvez toujours accéder à vos créations dans ',
  YOUR_NAME_KEY: 'Votre nom',
  YOUR_SELECTION_WILL_KEY:
    "Votre sélection sera utilisée comme votre chemin d'impression par défaut pour vos impressions futures.",
  YOUR_PROJECT_KEY: 'Votre projet :',
  PROJECT_NAME_ERROR_TEXT: 'Entrez un nom pour votre projet.',
  PROJECT_FOLDER_ERROR_TEXT: 'Entrez un nom pour le dossier de votre projet.',
  PIXELATION_WARNING_SETTINGS_KEY: "Paramètres d'avertissement lié aux pixels",
  MINIMUM_VIEWING_DISTANCE_KEY: 'Distance minimum de visualisation',
  BACKGROUND_UPLOAD_KEY: 'Arrière-plan',
  OBJECT_UPLOAD_KEY: 'objet',
  PHOTO_UPLOAD_KEY: 'photo',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Aucun contenu de rêve trouvé',
  NO_ELEMENT_ERROR_MESSAGE: 'Élément introuvable.',
  NO_MORE_IMAGES_FOUND_KEY: "Pas plus d'images trouvées",
  NO_PATTERN_ERROR_MESSAGE: 'Motifs introuvables.',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: "J'ai déjà un {0} Compte?",
  CHANGE_MEASURING_SYSTEM_KEY: 'Changer en {0}',
  DOWNLOADS_KEY: '{0} téléchargements',
  HEX_COLOR_KEY: 'Couleur Hex: {0}',
  NEAR_KEY: 'de près',
  FAR_KEY: 'de loin',
  CLOSE_UP_KEY: 'de très près',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    "Les images que vous essayez d'utiliser sont plus petites ou plus grandes que la zone de conception que vous utilisez.",
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    "Pour obtenir de meilleurs résultats, utilisez une image d'une résolution de 999",
  MESSAGE_KEY: 'Message :',
  VIEWS_KEY: '{0} vues',
  COST_DESCRIPTION_MESSAGE_KEY:
    "Ceci est le récapitulatif des frais associés au contenu Premium inclus dans votre création. {0} En sélectionnant Terminer, vous acceptez d'être facturé(e) des frais suivants par les fournisseurs de contenus.",
  DEFAULT_PRINTING_OPTION_KEY: "{0} est votre option d'impression par défaut,",
  CONFIRM_DREAMSTIME_ACCOUNT_KEY:
    "Vous n'avez pas encore de compte Dreamstime?",
  REGISTER_PATTERNSUB2:
    " vous obtiendrez des images haute résolution d'une valeur de 100 $ {0} pour aider avec tous vos besoins créatifs!",
  REGISTER_PATTERNSUB3:
    "Inscrivez-vous aujourd'hui et au cours des 30 prochains jours, téléchargez des fichiers de création à partir de notre base de contenu de 25 millions de photos et découvrez comment {0} peut vous aider à répondre à vos besoins créatifs.",
  ZOOM_WARNING_PIXELATED_TEXT:
    "L'échelle que vous avez appliquée risque de créer un effet de pixelisation sur votre image imprimée en cas de visualisation à {0} {1} * (la résolution actuelle de l'impression est de {2} dpi).",
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    "La distance de visibilité recommandée est de {0} {1}. Si cela ne convient pas, réduisez l'échelle de cette image ou la taille de votre mur.",
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    "La taille d'image minimum recommandée doit être de {0} x {1} pixels.",
  UPLOAD_STATUS: '{0}% sur {1}Mo',
  REGISTER_TO: 'Inscrivez-vous à {0}',
  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY:
    'Les dimensions minimales sont de {0} (l) sur {1} (h).',
  MINIMUM_HEIGHT_KEY: 'La hauteur minimum est de {0}.',
  MINIMUM_WIDTH_KEY: 'La largeur minimum est de {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Les dimensions maximales sont {0} (l) sur {1} (h).',
  MAXIMUM_WIDTH_KEY: 'La largeur maximum est de {0}.',
  MAXIMUM_HEIGHT_KEY: 'La hauteur maximum est de {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Entrez des dimensions numériques supérieures à zéro.',
  PROCESSING_FAILED: 'Échec du traitement. Réessayez plus tard',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Désolé, les fichiers PDF de plusieurs pages ne sont pas pris en charge.',
  MINIMUM_ZOOM_WARNING:
    "L'échelle de cet arrière-plan ne peut pas être davantage réduite car la hauteur ou largeur minimum requise pour couvrir votre mur a été atteinte.",
  OF_KEY: 'de',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Désolé, les fichiers PDF cryptés ne sont pas pris en charge.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importation du fichier {0} sur {1}',
  RECOLORING_KEY: 'Recoloration...',
  TEXT_COLOR_KEY: 'Couleur du texte',
  SOLID_COLOR_KEY: 'Couleur unie',
  AUTHENTICATE_DIALOG_TITLE:
    'Cette source de contenus est protégée par mot de passe',
  AUTHENTICATE_FAILED_MESSAGE: "Échec d'authentification !",
  DROPBOX_IMPORT_ERROR_HEADER:
    "Un problème est survenu lors de l'importation de certains fichier",
  MATERIAL_CHOICE_APPLIED: 'Choix du matériau appliqué.',
  FEEDBACK_PERMISSION_STRING_KEY:
    "J'autorise HP à me contacter à propos de mes commentaires",

  // Feedback string
  HP_FEEDBACK_TEXT: 'Nous aimerions avoir de vos nouvelles',
  FEEDBACK_QUERY_TEXT:
    'Globalement, dans quelle mesure êtes-vous satisfait avec nous?',
  VERY_SATISFIED_BUTTON_TEXT: 'Très satisfait',
  SATISFIED_BUTTON_TEXT: 'Satisfait',
  DISSATISFIED_BUTTON_TEXT: 'Mécontent',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Très insatisfait',
  FEEDBACK_IMPROVE_TEXT: 'Que pouvons-nous faire pour nous améliorer?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Déclaration de confidentialité',
  FEEDBACK_PLACEHOLDER_TEXT:
    'Nous examinons vos commentaires pour améliorer nos produits. Ne communiquez donc aucune donnée personnelle ni aucun contenu confidentiel ou exclusif.',
  DEFAULT_PROJECT_NAME: 'Projet',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choisissez votre ordinateur portable',
  SHOW_ALL_KEY: 'Afficher tout',
  Go_BACK_KEY: 'Retourner',
  FIRST_NAME_KEY: 'Prénom',
  LAST_NAME_KEY: 'Nom',
  PHONE_NUMBER_KEY: 'Numéro de téléphone',
  POSTAL_ADDRESS: 'Adresse postale', // Postal address
  COMPANY_NAME: 'Nom de la compagnie', // Company name
  INVALID_POSTAL_ADDRESS: 'Adresse postale non valide', // Invalid Postal address
  INVALID_COMPANY_NAME: 'Nom de société non valide', // Invalid Comapany name
  INVALID_PHONE_NUMBER_KEY: 'Numéro de téléphone invalide',
  TERMS_AND_CONDITIONS: 'J’accepte les termes et conditions',
  INVOICE_UPLOAD: 'Téléchargez la facture', // Upload Invoice
  INVOICE_FILE_MISSING: 'Fichier de facture manquant', // Invoice file missing
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'J’accepte que mes informations personnelles soient partagées avec HP pour être contacté à propos des futures campagnes HP.*',
  SERVICE_PROVIDER_CONDITION:
    'J’accepte que les données que je fournis puissent être partagées avec des fournisseurs de services aux fins du processus d’impression et de livraison.*',
  ORDER_DESIGN: 'Commander le design',
  SUBMIT_YOUR_DESIGN: 'Soumettre votre design',
  SUBMISSION_DESIGN_ORDER: 'Soumission d’une commande de design',
  ENTER_REQUIRED_FIELDS_KEY: 'Veuillez renseigner les champs obligatoires',
  ADDRESS_KEY: 'Adresse',
  INVALID_ADDRESS_KEY: 'Adresse non valide',
  CITY_KEY: 'Ville',
  INVALID_CITY_KEY: 'Ville non valide',
  COUNTRY_KEY: 'Pays',
  STATE_KEY: 'État',
  ZIP_KEY: 'Code postal',
  ORDER_NUMBER: 'Numéro de commande',
  INVALID_ZIP_KEY: 'Code postal non valide',
  NOTICE_KEY: 'Attention:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'pour un sticker parfaitement adapté à votre PC, vous devez sélectionner exactement le modèle de PC correspondant à votre achat et indiqué sur votre facture.',
  YOUR_DETAILS_KEY: 'Vos détails',
  APPLY_DESIGN_COMPETITION:
    'Déposez votre candidature pour le concours de design',
  RESTART_PROJECT_ALERT_TITLE: 'Redémarrer un projet ?',
  DISCARD_ALERT_MESSAGE: 'Votre projet actuel sera abandonné',
  RESTART: 'Redémarrer',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificat d’',
  AUTHENTICITY_STRING: 'authenticité',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE:
    'Avertissement concernant la taille de la page!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    "Ce modèle Inspiration est fourni avec une taille par défaut de {0} X {1} {2}. La taille de votre page sera automatiquement modifiée pour s'adapter à ce modèle.",
  MODIFY_SIZE_WARNING:
    "Si vous souhaitez redimensionner ce design, vous pouvez le faire dans l'onglet «Paramètres». Les éléments de conception peuvent nécessiter des modifications pour s'adapter aux dimensions souhaitées.",
  RANDOMIZE_KEY: 'Randomiser',
  PLEASE_WAIT: 'Merci de patienter',
  PROTECTING_YOUR_DATA: 'protection de vos données en cours...',
  SEARCH_YOUR_LAPTOP_KEY: 'Recherchez votre ordinateur portable', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    "Oups! Nous n'avons trouvé aucun ordinateur portable pour votre recherche.", // Google translated

  // new
  ZOOM_IN_KEY: 'Agrandir le zoom', // Zoom In
  ZOOM_OUT_KEY: 'Zoom arrière', // Zoom Out
  ADOBE_STOCK_SEARCH_TITLE: 'Recherche Adobe Stock', // Adobe Stock Search
  HP_MOSAIC_SEARCH_TITLE: 'HP mosaïque', // HP mosaic
  SERIAL_NUMBER_KEY: 'Numéro de série',
  LOCKED_PROJECT: 'Projet verrouillé',
  LOCKED_MESSAGE:
    'Ce projet a été commandé et ne peut pas être modifié. Vous pouvez seulement visualiser ce projet.',
  EXPIRED_PROJECT: 'Projet expiré',
  EXPIRED_MESSAGE: 'Ce projet a expiré.',
  DELETED_PROJECT: 'Projet supprimé',
  DELETED_MESSAGE: 'Ce projet a été supprimé.',
  CHOOSE_GROUP_TYPE: 'Choisir le type de {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Entrez des nombres supérieurs à zéro.',
  SIZE_KEY: 'Taille',
  DISTANCE_FROM_KEY: 'Distance à partir de/du',
  MYROOM_UPPERCASE_KEY: 'MA CHAMBRE',
  FURNITURE_KEY: 'Mobilier',
  FIXTURES_KEY: 'Matériels',
  ADD_A_WALL_KEY: 'Ajouter un mur',
  SELECT_A_WALL_KEY: 'Sélectionner un mur',
  LEFT_KEY: 'Gauche',
  RIGHT_KEY: 'Droite',
  DELETE_WALL_KEY: 'Supprimer le mur',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choisissez le type de toile',
  MAXIMUM_WALL_SIZE_KEY: 'La taille maximum du mur est de {0} {1} carrés.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'La hauteur de la toile est supérieure à celle du mur.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'La largeur de la toile est supérieure à celle du mur.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Le nombre maximum de colonnes pour cette largeur est de {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Le nombre maximum de lignes pour la hauteur actuelle est de {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'La largeur du mur est inférieure à celle de la toile.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'La largeur minimum du mur doit être de {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'La hauteur minimum du mur doit être de {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'La hauteur du mur est inférieure à celle de la toile.',
  MAXIMUM_WALL_HEIGHT_KEY: 'La hauteur maximum du mur est de {0} {1}.',
  FINISHING_KEY: 'finalisation',
  MIRROR_KEY: 'Miroir',
  NATURAL_KEY: 'Naturel',
  ROWS_KEY: 'Lignes',
  COLUMNS_KEY: 'Colonnes',
  DEFAULT_WALL_SIZE_KEY: 'Taille de mur par défaut',
  EDIT_KEY: 'Modifier',
  TOP_KEY: 'Haut',
  BOTTOM_KEY: 'Bas'
};
